document.addEventListener("DOMContentLoaded", () => {
  const setupDropdown = (buttonSelector, menuSelector, textSelector) => {
    const dropdownButton = document.querySelector(buttonSelector);
    const dropdownMenu = document.querySelector(menuSelector);
    const selectedTextParagraph = textSelector ? document.querySelector(textSelector) : null;

    let isOpen = false;

    // Function to toggle dropdown visibility
    const toggleDropdown = () => {
      isOpen = !isOpen;
      dropdownMenu.classList.toggle("opacity-0", !isOpen);
      dropdownMenu.classList.toggle("opacity-100", isOpen);
      dropdownMenu.classList.toggle("hidden", !isOpen);
      dropdownMenu.classList.toggle("block", isOpen);
      dropdownButton.setAttribute("aria-expanded", isOpen.toString());
    };

    // Function to handle option selection
    const handleOptionClick = (event) => {
      console.log('TextSelector:', textSelector);
      console.log('SelectedTextParagraph:', selectedTextParagraph);
      console.log('Event Target:', event.target.textContent);

      if (!textSelector || !selectedTextParagraph) return;
      const selectedOption = event.target;
      if (selectedOption && selectedOption.textContent) {
        selectedTextParagraph.textContent = selectedOption.textContent.trim();
        toggleDropdown(); // Close dropdown after selection
      }
    };

    // Event listener for dropdown button
    dropdownButton.addEventListener("click", () => {
      toggleDropdown();
    });

    if (textSelector && selectedTextParagraph) {
      dropdownMenu.querySelectorAll("li").forEach((option) => {
        option.addEventListener("click", (event) => {
          handleOptionClick(event);
        });
      });
    }

    // Close dropdown if clicked outside
    document.addEventListener("click", (event) => {
      if (
        !dropdownMenu.contains(event.target) &&
        !dropdownButton.contains(event.target)
      ) {
        if (isOpen) {
          toggleDropdown();
        }
      }
    });
  };

  // Initialize the dropdowns
  setupDropdown(
    'button[data-dropdown="personTypeListbox"]',
    'ul[role="personTypeList"]',
    'button[data-dropdown="personTypeListbox"] .text-sm.font-semibold'
  );

  setupDropdown(
    'button[data-dropdown="regionList"]',
    'ul[role="regionList"]',
    'button[data-dropdown="regionList"] .text-sm.font-semibold'
  );

  //nav
  setupDropdown(
    'button[data-dropdown="programmesMenuDropdown"]',
    'ul[role="programmesMenuDropdown"]',
    null,
  );

  setupDropdown(
    'button[data-dropdown="candidateMenuDropdown"]',
    'ul[role="candidateMenuDropdown"]',
    null,
  );

  setupDropdown(
    'button[data-dropdown="sponsorMenuDropdown"]',
    'ul[role="sponsorMenuDropdown"]',
    null,
  );

  setupDropdown(
    'button[data-dropdown="aboutMenuDropdown"]',
    'ul[role="aboutMenuDropdown"]',
    null,
  );
});